// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var HasField = function (getField) {
    this.getField = getField;
};
var hasFieldRecord = function (dictIsSymbol) {
    return function (dictCons) {
        return new HasField(function (label) {
            return $foreign.unsafeGet(Data_Symbol.reflectSymbol(dictIsSymbol)(label));
        });
    };
};
var getField = function (dict) {
    return dict.getField;
};
module.exports = {
    HasField: HasField,
    getField: getField,
    hasFieldRecord: hasFieldRecord
};
//# sourceMappingURL=index.js.map
